import InteractiveList from './InteractiveList';

export default InteractiveList;
